import React, { SVGProps } from 'react';

/**
 * viewBox='0 0 24 24' er den faktiske størrelsen på svg'en. De to siste veridene må være svgen sin
 * faktiske bredde og høyde. Hvis ikke vil svg'en bli strukket til å fylle hele plassen den har.
 * widt og height er satt til 100% for å fylle hele plassen den har.
 * @param props
 * @constructor
 */
interface SvgProps extends SVGProps<SVGSVGElement> {
	pathFill?: string;
	color?: string;
}

export const Kjørefelt: React.FC<SvgProps> = ({ pathFill = 'white', ...props }) => {
	return (
		<svg
			width='100%'
			height='100%'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<g id='Ikon'>
				<path
					id='Vector'
					d='M5.11554 1.68408C4.25837 1.68408 3.49426 2.21981 3.20666 3.02622L0.122001 11.5978C-0.354514 12.9202 0.623892 14.3159 2.03088 14.3159H13.9691C15.3761 14.3159 16.3545 12.9202 15.878 11.5978L12.7933 3.02622C12.5029 2.21981 11.7388 1.68408 10.8845 1.68408H5.11554ZM4.48112 3.48581C4.57699 3.21795 4.83357 3.0375 5.11836 3.0375H7.32329V3.7142C7.32329 4.08921 7.62499 4.39091 8 4.39091C8.37501 4.39091 8.67671 4.08921 8.67671 3.7142V3.0375H10.8845C11.1692 3.0375 11.4258 3.21513 11.5217 3.48581L14.6064 12.0574C14.7643 12.4973 14.4372 12.9625 13.9691 12.9625H8.67671V12.2858C8.67671 11.9108 8.37501 11.6091 8 11.6091C7.62499 11.6091 7.32329 11.9108 7.32329 12.2858V12.9625H2.03088C1.56282 12.9625 1.23575 12.4973 1.39365 12.0574L4.4783 3.48581H4.48112ZM8.67671 6.87217C8.67671 6.49716 8.37501 6.19546 8 6.19546C7.62499 6.19546 7.32329 6.49716 7.32329 6.87217V9.12786C7.32329 9.50287 7.62499 9.80457 8 9.80457C8.37501 9.80457 8.67671 9.50287 8.67671 9.12786V6.87217Z'
					fill={pathFill}
				/>
			</g>
		</svg>
	);
};
